export function endOfDay(date: Date): Date | null {
    if (!date) return null;
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999);
}

export function startOfDay(date: Date): Date | null {
    if (!date) return null;
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
}

export function startOfMonth(date: Date): Date | null {
    if (!date) return null;
    return new Date(date.getFullYear(), date.getMonth(), 1);
}

export function endOfMonth(date: Date): Date | null {
    if (!date) return null;
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
}

export function formatDateToYYYYMMDD(date: Date) {
    if (!date) return undefined;
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // getMonth() returns 0-11, so add 1
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
}

export function mergeDateAndTime(date: Date, time: string): Date {
    const mergedDate = new Date(date);

    const [hours, minutes] = time.split(':').map(Number);

    mergedDate.setHours(hours);
    mergedDate.setMinutes(minutes);
    mergedDate.setSeconds(0);
    mergedDate.setMilliseconds(0);

    return mergedDate;
}

export function parseISODate(isoDate: string): { date: Date, time: string } {
    const date = new Date(isoDate);
    const localDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));

    const hours: string = localDate.getUTCHours().toString().padStart(2, '0');
    const minutes: string = localDate.getUTCMinutes().toString().padStart(2, '0');
    const time = `${hours}:${minutes}`;

    return {date, time};
}

export function localDateShift(isoDate: string): string {
    const date = new Date(isoDate);
    return new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString();
}

